/* galeria-carrusel.js — la galeria de las paginas de papel.
 *
 * Fuente unica de la galeria: carrusel con bucle, arrastre con mouse, deslizar
 * con el dedo, miniaturas sincronizadas y lightbox a pantalla completa.
 *
 * Por que existe: esto vivia dentro de sections/product-quoter.liquid y habria
 * que copiarlo a cada seccion nueva. Es el mismo problema que tenian las diez
 * copias del motor del cotizador. Aqui se arregla una vez y lo heredan todas.
 *
 * Se monta solo: cualquier elemento con [data-galeria] en la pagina queda
 * enganchado, sin que la seccion tenga que llamar a nada.
 *
 * No sabe nada del cotizador ni de precios. Solo fotos.
 */
(function () {
  'use strict';

  function montar(raiz) {
    if (raiz.dataset.galeriaLista) return;
    raiz.dataset.galeriaLista = '1';

    var pista = raiz.querySelector('[data-pista]');
    if (!pista) return;
    var fotos = pista.querySelectorAll(':scope > a');
    if (!fotos.length) return;

    // ── Las copias de los extremos ──
    // Sin ellas el dedo se detiene en la ultima foto: un contenedor con scroll
    // nativo no da la vuelta. Con una copia de la ultima delante y una de la
    // primera detras, al pasar de largo se salta a la de verdad sin animar y
    // el salto no se ve, porque la copia muestra la misma imagen.
    var conCopias = fotos.length > 1;
    if (conCopias) {
      var copiaFin = fotos[fotos.length - 1].cloneNode(true);
      var copiaIni = fotos[0].cloneNode(true);
      copiaFin.setAttribute('data-copia', 'fin');
      copiaIni.setAttribute('data-copia', 'ini');
      // Las copias no se anuncian: para un lector de pantalla el carrusel
      // sigue teniendo doce fotos, no catorce.
      copiaFin.setAttribute('aria-hidden', 'true');
      copiaIni.setAttribute('aria-hidden', 'true');
      copiaFin.tabIndex = -1;
      copiaIni.tabIndex = -1;
      pista.insertBefore(copiaFin, fotos[0]);
      pista.appendChild(copiaIni);

      // Insertar delante corre el contenido un hueco entero. Chrome lo
      // compensa solo, Safari en iPhone no: alli el carrusel se quedaba en el
      // scroll 0, que ahora es la COPIA de la ultima foto —la miniatura decia
      // «1» y la grande mostraba la 12—. Se fija a mano y se deja de depender
      // de una correccion que un navegador hace y otro no.
      var alInicio = function () {
        if (!pista.clientWidth) return false;
        pista.classList.add('saltando');   // sin encaje ni animacion
        pista.scrollLeft = pista.clientWidth;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { pista.classList.remove('saltando'); });
        });
        return true;
      };
      // Antes de maquetar, clientWidth es 0: se intenta ya y se reintenta
      // despues del primer pintado.
      if (!alInicio()) requestAnimationFrame(alInicio);
      else requestAnimationFrame(alInicio);
      // Al cambiar de tamaño, una posicion en pixeles deja de corresponder a
      // una foto: se vuelve a la que se estaba viendo.
      window.addEventListener('resize', function () {
        pista.classList.add('saltando');
        pista.scrollLeft = posDe(actual) * pista.clientWidth;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { pista.classList.remove('saltando'); });
        });
      });
    }
    // La posicion en la PISTA de la foto real i. Con copias hay un hueco al
    // principio, asi que todo va corrido en uno.
    function posDe(i) { return conCopias ? i + 1 : i; }

    var tabs = raiz.querySelectorAll('[data-tab]');
    var tiras = raiz.querySelector('[data-tiras]');
    var cont = raiz.querySelector('[data-contador]');
    var total = fotos.length;
    var actual = 0;
    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ────────────────────────────────────────────── arrastrar con el mouse
    // Es lo unico que el navegador no regala: deslizar con el dedo scrollea
    // solo, pero arrastrar con el mouse no mueve un contenedor con scroll.
    //
    // Sirve para las dos tiras de la galeria, que se arrastran igual pero
    // terminan distinto:
    //   · con «ir» es un carrusel y al soltar tiene que encajar en una foto
    //   · sin «ir» es scroll libre —la tira de miniaturas— y se queda donde la
    //     dejaron
    //
    // Devuelve una funcion que dice si lo ultimo fue arrastre, para que quien
    // tenga enlaces o botones dentro pueda cancelar el clic.
    function arrastrable(caja, leer, ir, cuantos) {
      var abajo = false, activo = false, x0 = 0, s0 = 0, movido = 0;
      var pid = null, reloj = null;

      caja.addEventListener('pointerdown', function (ev) {
        // Solo mouse: con el dedo ya scrollea el navegador y meterse en medio
        // le quita la inercia.
        if (ev.button !== 0 || ev.pointerType === 'touch') return;
        abajo = true; activo = false; movido = 0; pid = ev.pointerId;
        x0 = ev.clientX; s0 = caja.scrollLeft;
      });

      caja.addEventListener('pointermove', function (ev) {
        if (!abajo) return;
        var dx = ev.clientX - x0;
        movido = Math.max(movido, Math.abs(dx));
        // La captura se toma cuando el arrastre empieza DE VERDAD. Tomarla en
        // el pointerdown desvia tambien el click al contenedor, y el enlace de
        // la foto no lo recibe nunca: un clic limpio dejaba de abrir el visor.
        if (!activo) {
          if (movido <= 4) return;
          activo = true;
          caja.classList.add('arrastrando');
          try { caja.setPointerCapture(pid); } catch (e) {}
        }
        caja.scrollLeft = s0 - dx;
      });

      function soltar(ev) {
        abajo = false;
        if (!activo) return;                 // fue un clic, no un arrastre
        activo = false;
        try { caja.releasePointerCapture(ev.pointerId); } catch (e) {}

        // La tira libre no encaja en nada: se queda donde la soltaron.
        if (ir) {
          // Se mide ANTES de devolver el encaje. Al restaurarlo el navegador
          // reencaja en el acto y borra el desplazamiento: leyendo despues, un
          // arrastre de media pantalla daba cero y nunca cambiaba de foto.
          var i = leer();
          var base = caja.dataset.pos ? Number(caja.dataset.pos) : i;
          var d = caja.scrollLeft - base * caja.clientWidth;
          var salto = Math.abs(d) > caja.clientWidth / 4 ? (d > 0 ? 1 : -1) : 0;
          ir((i + salto + cuantos) % cuantos);
        }

        clearTimeout(reloj);
        reloj = setTimeout(function () {
          caja.classList.remove('arrastrando');
          // Sin esto, arrastrar con el mouse hasta el extremo dejaba la tira
          // pegada al borde: durante el arrastre no se normaliza, y al soltar
          // ya no llega ningun evento de scroll que lo dispare.
          if (caja === tiras) normalizarTira();
        }, 420);
      }
      caja.addEventListener('pointerup', soltar);
      caja.addEventListener('pointercancel', soltar);
      // Arrastrar una imagen es el gesto por omision del navegador y se come
      // el nuestro.
      caja.addEventListener('dragstart', function (ev) { ev.preventDefault(); });

      return function fueArrastre() {
        var si = movido > 4;
        movido = 0;
        return si;
      };
    }

    // ───────────────────────────────────────────── el carrusel de la pagina
    function irA(i, ya) {
      // Con copias YA NO hay salto seco al dar la vuelta: se avanza a la copia,
      // que esta pegada al lado, y el enderezado ocurre despues sin verse. El
      // movimiento es continuo en las dos direcciones.
      var dest = actual === total - 1 && i === 0 ? total + 1 :
                 actual === 0 && i === total - 1 ? 0 :
                 posDe(i);
      pista.scrollTo({
        left: dest * pista.clientWidth,
        behavior: (ya || !suave) ? 'auto' : 'smooth'
      });
      marcar(i);
      // El enderezado NO se programa aqui. Lo dispara el detector de scroll
      // cuando el carrusel se detiene, que es el unico momento en que es
      // invisible: con un temporizador fijo, un dedo que volvia a moverse
      // dentro de esa ventana chocaba con el salto y la foto se sentia pegada.
    }

    // Tras aterrizar en una copia se salta a la original. Sin animar y con el
    // encaje apagado un instante: si no, el navegador vuelve a encajar donde
    // estaba y deshace el salto.
    var relojEnd = null;
    function enderezar(i, espera) {
      clearTimeout(relojEnd);
      relojEnd = setTimeout(function () {
        pista.classList.add('saltando');
        pista.scrollLeft = posDe(i) * pista.clientWidth;
        // Dos cuadros bastan para que el navegador aplique el scroll antes de
        // devolverle el encaje.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { pista.classList.remove('saltando'); });
        });
      }, espera);
    }

    // Las fotos a las que se puede llegar con UN gesto, cargadas ya. En un
    // carrusel horizontal el navegador considera «fuera de pantalla» todo lo
    // que no es la foto actual, asi que con lazy a secas se deslizaba hacia un
    // hueco.
    function cargarVecinas(i) {
      var slides = pista.children;
      var quiero = [i - 1, i, i + 1].map(function (n) {
        return ((n % total) + total) % total;
      });
      quiero.forEach(function (n) {
        var a = slides[posDe(n)];
        if (!a) return;
        var im = a.querySelector('img');
        // Se QUITA el atributo: eso dispara la carga en el acto. Cambiarlo a
        // «eager» no siempre lo hace.
        if (im && im.hasAttribute('loading')) im.removeAttribute('loading');
      });
    }

    function marcar(i) {
      cargarVecinas(i);
      if (i === actual && cont && cont.textContent) return;
      actual = i;
      if (cont) cont.textContent = (i + 1) + ' / ' + total;
      tabs.forEach(function (t, n) {
        t.setAttribute('aria-selected', String(n === i));
        // Recorrido movil: dentro de un tablist solo la pestaña activa entra
        // con Tab; entre ellas se navega con las flechas.
        t.tabIndex = (n === i) ? 0 : -1;
      });
      // Y las COPIAS. Sin esto, mirando una copia la miniatura activa se
      // quedaba gris: marcar() solo conocia las doce originales.
      if (tiras) {
        [].forEach.call(tiras.children, function (b, n) {
          b.setAttribute('aria-selected', String(n % total === i));
        });
      }
      centrar(i);
      pintarFlechasTira();
    }

    // La miniatura activa se CENTRA en la tira. Se mide con rectangulos y no
    // con offsetLeft: offsetLeft cuenta desde el ancestro posicionado mas
    // cercano, y la tira no lo esta.
    function centrar(i) {
      var a = tabs[i];
      if (!a || !tiras) return;
      var rt = a.getBoundingClientRect(), rc = tiras.getBoundingClientRect();
      var destino = tiras.scrollLeft + (rt.left - rc.left) - (rc.width - rt.width) / 2;
      // Con la lista duplicada ya no hay tope contra el que recortar: el
      // desplazamiento se normaliza al rango de una copia y la propia tira se
      // encarga del resto.
      if (anchoTira) {
        // Se lleva al rango de la copia del MEDIO, que es donde se vive.
        while (destino < anchoTira) destino += anchoTira;
        while (destino >= anchoTira * 2) destino -= anchoTira;
        tiras.scrollLeft = destino;
      } else {
        var tope = tiras.scrollWidth - tiras.clientWidth;
        tiras.scrollLeft = Math.max(0, Math.min(tope, destino));
      }
    }

    // Al deslizar con el dedo nadie llamo a irA: hay que leer donde quedo
    // cuando el scroll se detiene.
    var reloj = null;
    pista.addEventListener('scroll', function () {
      if (pista.classList.contains('arrastrando')) return;
      clearTimeout(reloj);
      reloj = setTimeout(function () {
        // Con copias basta dividir: todas las diapositivas miden lo mismo.
        var pos = Math.round(pista.scrollLeft / pista.clientWidth);
        var real = !conCopias ? pos :
                   pos === 0 ? total - 1 :
                   pos === total + 1 ? 0 :
                   pos - 1;
        marcar(real);
        // Si el dedo quedo sobre una copia, se endereza en el acto: nadie lo
        // ve porque la copia muestra exactamente la misma foto.
        if (conCopias && (pos === 0 || pos === total + 1)) enderezar(real, 0);
      }, 120);
    }, { passive: true });

    // El arrastre mide contra la POSICION en la pista, que con copias no es el
    // indice de la foto.
    // ── La red del deslizamiento con el dedo ──
    // El scroll nativo se siente mejor cuando funciona, asi que se deja
    // primero. Esto solo cubre el caso en que el gesto fue claro pero el
    // navegador no llego a cambiar de foto.
    (function () {
      var x0 = 0, iniciado = false, desde = 0;
      pista.addEventListener('touchstart', function (ev) {
        if (ev.touches.length !== 1) { iniciado = false; return; }
        x0 = ev.touches[0].clientX;
        desde = actual;
        iniciado = true;
      }, { passive: true });

      pista.addEventListener('touchend', function (ev) {
        if (!iniciado) return;
        iniciado = false;
        var t = ev.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - x0;
        // Un quinto de la pantalla: quien arrastra eso ya decidio pasar.
        if (Math.abs(dx) < pista.clientWidth * 0.22) return;
        var quiere = (desde + (dx < 0 ? 1 : -1) + total) % total;
        // Se le da su tiempo al scroll nativo. Si llego, no se toca nada.
        setTimeout(function () {
          if (actual !== desde) return;
          irA(quiere);
        }, 260);
      }, { passive: true });
    })();

    var fueArrastre = arrastrable(pista, function () {
      pista.dataset.pos = String(posDe(actual));
      return actual;
    }, irA, total);

    var prev = raiz.querySelector('[data-prev]'), sig = raiz.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { irA((actual - 1 + total) % total); });
    if (sig) sig.addEventListener('click', function () { irA((actual + 1) % total); });

    pista.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowRight') { ev.preventDefault(); irA((actual + 1) % total); }
      else if (ev.key === 'ArrowLeft') { ev.preventDefault(); irA((actual - 1 + total) % total); }
      else if (ev.key === 'Home') { ev.preventDefault(); irA(0); }
      else if (ev.key === 'End') { ev.preventDefault(); irA(total - 1); }
      else if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); fotos[actual].click(); }
    });

    // ── Flechas con el mouse encima, sin necesidad de hacer clic antes ──
    // El teclado de arriba solo responde si la pista tiene el foco, y para
    // eso hay que haber hecho clic o tabulado hasta ahi. Quien simplemente
    // pasa el mouse por la foto grande y aprieta una flecha espera que
    // cambie de foto igual, como en cualquier galeria. Se activa con el
    // mouse encima y se apaga si el foco esta en un campo de texto (el
    // cotizador vive en la misma pagina).
    var sobreFoto = false;
    raiz.addEventListener('mouseenter', function () { sobreFoto = true; });
    raiz.addEventListener('mouseleave', function () { sobreFoto = false; });
    document.addEventListener('keydown', function (ev) {
      if (!sobreFoto) return;
      var t = document.activeElement;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      if (ev.key === 'ArrowRight') { ev.preventDefault(); irA((actual + 1) % total); }
      else if (ev.key === 'ArrowLeft') { ev.preventDefault(); irA((actual - 1 + total) % total); }
    });

    // ── La tira, tambien infinita ──
    // Misma idea que arriba pero al reves: en vez de dos copias en los
    // extremos se duplica la lista ENTERA una vez. Cuando el scroll pasa del
    // ancho de la primera copia se le resta ese ancho; como las dos copias son
    // identicas, el salto no se ve. Asi el dedo puede seguir en cualquiera de
    // los dos sentidos sin encontrar un tope.
    // TRES copias de la lista, y se vive siempre en la del medio.
    //
    // Con dos no bastaba: el borde izquierdo era el 0 real del contenedor, y un
    // contenedor con scroll no baja de 0 —se detiene y no dispara evento, asi
    // que nunca habia ocasion de saltar—. Con tres, la zona segura es [A, 2A] y
    // queda una copia entera de margen a cada lado: los bordes reales no se
    // alcanzan nunca.
    var anchoTira = 0;
    function normalizarTira() {
      if (!anchoTira) return;
      var x = tiras.scrollLeft;
      if (x < anchoTira * 0.5) tiras.scrollLeft = x + anchoTira;
      else if (x > anchoTira * 2.5) tiras.scrollLeft = x - anchoTira;
    }
    function medirTira() {
      anchoTira = tiras.scrollWidth / 3;
      // Colocarse a ciegas al inicio de la copia del medio borraba el centrado
      // que centrar() acababa de hacer —cuando corrio, anchoTira todavia era 0—
      // y en telefono dejaba la miniatura activa fuera de la vista.
      tiras.scrollLeft = anchoTira;
      // En telefono la activa va CENTRADA, que es ademas lo que hace el resto
      // del tiempo. En escritorio se queda al inicio: ahi la foto 1 pegada a la
      // izquierda se lee como «estas en la primera».
      if (window.matchMedia('(max-width: 749px)').matches) centrar(actual);
    }
    if (tiras && tabs.length > 1) {
      var copias = document.createDocumentFragment();
      for (var v = 0; v < 2; v++) {
        tabs.forEach(function (t) {
          var c = t.cloneNode(true);
          c.setAttribute('data-copia', '1');
          c.setAttribute('aria-hidden', 'true');
          c.tabIndex = -1;
          c.removeAttribute('role');     // fuera del tablist: no son pestañas
          copias.appendChild(c);
        });
      }
      tiras.appendChild(copias);
      requestAnimationFrame(medirTira);
      window.addEventListener('resize', medirTira);
      tiras.addEventListener('scroll', function () {
        if (tiras.classList.contains('arrastrando')) return;
        normalizarTira();
      }, { passive: true });
    }

    var arrastrarTira = tiras ? arrastrable(tiras) : null;

    // Los clics van por DELEGACION sobre la tira: las copias son nodos creados
    // despues y, con manejadores puestos uno a uno, no tendrian ninguno —quien
    // pinchara una copia no veria pasar nada—.
    if (tiras) {
      tiras.addEventListener('click', function (ev) {
        var b = ev.target.closest ? ev.target.closest('button') : null;
        if (!b || b.parentNode !== tiras) return;
        // Sin esta guarda, arrastrar la tira terminaba cambiando la foto: el
        // gesto acaba en un clic sobre la miniatura que quedo bajo el cursor.
        if (arrastrarTira && arrastrarTira()) return;
        // La posicion en la tira, modulo las originales: la copia numero 15 es
        // la foto 3.
        var todas = tiras.children;
        var pos = [].indexOf.call(todas, b);
        if (pos >= 0) irA(pos % total);
      });
    }

    tabs.forEach(function (t, n) {
      t.addEventListener('keydown', function (ev) {
        var d = ev.key === 'ArrowRight' ? 1 : ev.key === 'ArrowLeft' ? -1 : 0;
        var destino = null;
        if (d) destino = (n + d + total) % total;
        else if (ev.key === 'Home') destino = 0;
        else if (ev.key === 'End') destino = total - 1;
        if (destino === null) return;
        ev.preventDefault();
        irA(destino);
        tabs[destino].focus();
      });
    });

    // Las flechas de la tira mueven una pantalla de miniaturas. Se apagan, no
    // desaparecen, para que la tira no cambie de ancho.
    // La tira da la vuelta, igual que la foto grande. Las flechas solo se apagan
    // cuando no hay NADA que desplazar: si siempre hay a donde ir, apagarlas
    // mentiria.
    function pintarFlechasTira() {
      var p = raiz.querySelector('[data-tprev]'), n = raiz.querySelector('[data-tnext]');
      if (!p || !n || !tiras) return;
      var desborda = tiras.scrollWidth > tiras.clientWidth + 2;
      p.disabled = n.disabled = !desborda;
    }

    // Cuanto queda por desplazar, y el tope.
    function topeTira() { return tiras.scrollWidth - tiras.clientWidth; }
    var tp = raiz.querySelector('[data-tprev]'), tn = raiz.querySelector('[data-tnext]');
    if (tp && tn && tiras) {
      // Al llegar a un extremo se salta al otro. El salto es seco a proposito:
      // animarlo cruzaria las doce miniaturas al reves, que es justo lo que se
      // quiere evitar —y es la misma decision que en la foto grande—.
      // Ya no hay que tratar los extremos: la propia tira los resuelve al
      // pasar de largo, igual que con el dedo.
      tp.addEventListener('click', function () {
        tiras.scrollLeft -= tiras.clientWidth * 0.8;
      });
      tn.addEventListener('click', function () {
        tiras.scrollLeft += tiras.clientWidth * 0.8;
      });
      tiras.addEventListener('scroll', pintarFlechasTira, { passive: true });
      window.addEventListener('resize', pintarFlechasTira);
    }

    // ────────────────────────────────────────────────────────── el lightbox
    // <dialog> + showModal(): el navegador lo pone en su capa superior, asi que
    // no hay z-index que pelear, y trae de fabrica el fondo oscurecido, Escape,
    // la trampa de foco, el resto de la pagina inerte y la vuelta del foco.
    var lb = raiz.querySelector('[data-lb]');
    if (lb && typeof lb.showModal === 'function') (function () {
      var lbp = lb.querySelector('[data-lbpista]');
      var lbSlides = lbp.querySelectorAll('[data-lbslide]');
      var lbCont = lb.querySelector('[data-lbcontador]');
      var lbActual = 0;

      function lbIr(i, ya) {
        var vuelta = (lbActual === total - 1 && i === 0) || (lbActual === 0 && i === total - 1);
        lbp.scrollTo({
          left: i * lbp.clientWidth,
          behavior: (ya || vuelta || !suave) ? 'auto' : 'smooth'
        });
        lbActual = i;
        if (lbCont) lbCont.textContent = (i + 1) + ' / ' + total;
      }

      var lbReloj = null;
      lbp.addEventListener('scroll', function () {
        if (lbp.classList.contains('arrastrando')) return;
        clearTimeout(lbReloj);
        lbReloj = setTimeout(function () {
          lbIr(Math.round(lbp.scrollLeft / lbp.clientWidth), true);
        }, 100);
      }, { passive: true });

      var lbFueArrastre = arrastrable(lbp, function () { return lbActual; }, lbIr, total);

      // Por delegacion y no uno por uno: las copias de los extremos son nodos
      // creados despues y no tendrian manejador.
      pista.addEventListener('click', function (ev) {
        var a = ev.target.closest ? ev.target.closest('a') : null;
        if (!a || a.parentNode !== pista) return;
        ev.preventDefault();
        // Arrastrar termina en un clic sobre el enlace. Sin esta guarda, mover
        // la foto con el mouse abriria el visor.
        if (fueArrastre()) return;
        lb.showModal();
        lbIr(actual, true);       // el ancho solo se puede medir ya abierto
      });

      var lp = lb.querySelector('[data-lbprev]'), ln = lb.querySelector('[data-lbnext]');
      if (lp) lp.addEventListener('click', function () { lbIr((lbActual - 1 + total) % total); });
      if (ln) ln.addEventListener('click', function () { lbIr((lbActual + 1) % total); });
      var lx = lb.querySelector('[data-lbcerrar]');
      if (lx) lx.addEventListener('click', function () { lb.close(); });

      lb.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowRight') { ev.preventDefault(); lbIr((lbActual + 1) % total); }
        else if (ev.key === 'ArrowLeft') { ev.preventDefault(); lbIr((lbActual - 1 + total) % total); }
      });

      // Clic fuera de la foto cierra.
      lb.addEventListener('click', function (ev) {
        if (lbFueArrastre()) return;
        if (ev.target.closest('button')) return;
        var im = lbSlides[lbActual].querySelector('img').getBoundingClientRect();
        var dentro = ev.clientX >= im.left && ev.clientX <= im.right &&
                     ev.clientY >= im.top && ev.clientY <= im.bottom;
        if (!dentro) lb.close();
      });

      // Al cerrar, el carrusel de la pagina queda en la foto que se miraba.
      lb.addEventListener('close', function () {
        if (lbActual !== actual) irA(lbActual, true);
      });

      // Si cambia el tamaño de la ventana, la posicion en pixeles deja de
      // corresponder a la foto.
      window.addEventListener('resize', function () {
        if (lb.open) lbIr(lbActual, true);
      });
    })();

    marcar(0);
    cargarVecinas(0);
  }

  function montarTodas() {
    document.querySelectorAll('[data-galeria]').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montarTodas);
  } else {
    montarTodas();
  }
  // El editor de temas repinta secciones sin recargar la pagina.
  document.addEventListener('shopify:section:load', montarTodas);
})();
